import { useCallback, useState } from "react";
import { useDispatch } from "react-redux";
import {
  searchImageFileUploaded,
  setCardslistLoading,
  setIsImageUploading,
  setNavigationCluster,
  setNavigationClusterLoader,
  setSimilarityData,
  setSimilarityVertex,
} from "redux/SingleDataset/actions";
import useAllQueryParamsFilters from "./useAllQueryParamsFilters";
import { useParams } from "react-router";
import { useSearchParams } from "react-router-dom";
import {
  AUTOMATIC_FLAT_RESPONSE_PARAMETER,
  PAGE_PARAMETER,
  VERTEX_ID,
  VERTEX_SIMILARITY,
  VERTEX_TYPE,
} from "helpers/constants/miscellaneous";

type HandleVisualSearchOptions = {
  flatResponse?: boolean;
};

export const useImageUpload = (onUpload?: () => void) => {
  const queryParamsFilters = useAllQueryParamsFilters();
  const { datasetId } = useParams();
  const dispatch = useDispatch();
  const [searchParams, setSearchParams] = useSearchParams();
  const [file, setFile] = useState<File | null>(null);
  const [cropData, setCropData] = useState<any>(null);

  const handleVisualSearch = useCallback(
    (cropData: any, options?: HandleVisualSearchOptions) => {
      const boundingBoxValues = `${cropData.x},${cropData.y},${cropData.x1},${cropData.y1}`;
      dispatch(setIsImageUploading(false));
      dispatch(setCardslistLoading(true));
      dispatch(setSimilarityData(null));
      dispatch(setNavigationClusterLoader(true));
      dispatch(setNavigationCluster(null));
      dispatch(setSimilarityVertex(null));

      dispatch(
        searchImageFileUploaded(
          datasetId,
          file!,
          queryParamsFilters,
          cropData.file,
          cropData.interacted ? boundingBoxValues : undefined,
        ) as any,
      )
        .then((anchorMediaId: string) => {
          searchParams.set(VERTEX_ID, anchorMediaId);
          searchParams.set(VERTEX_TYPE, "UPLOAD");
          searchParams.set(PAGE_PARAMETER, "1");
          searchParams.delete(VERTEX_SIMILARITY);
          if (options?.flatResponse) {
            searchParams.set(AUTOMATIC_FLAT_RESPONSE_PARAMETER, "true");
          }
          setSearchParams(searchParams);
        })
        .catch(() => {
          searchParams.delete(VERTEX_ID);
          searchParams.delete(VERTEX_TYPE);
          searchParams.delete(VERTEX_SIMILARITY);
          if (options?.flatResponse) {
            searchParams.delete(AUTOMATIC_FLAT_RESPONSE_PARAMETER);
          }
          setSearchParams(searchParams);
          window.location.reload();
        })
        .finally(() => onUpload?.());
    },
    [
      file,
      datasetId,
      searchParams,
      queryParamsFilters,
      dispatch,
      setSearchParams,
      onUpload,
    ],
  );

  return {
    file,
    setFile,
    cropData,
    setCropData,
    handleVisualSearch,
  };
};
